import axiosInstance from "./axiosInstance";

const inventoryService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/inventory/create', payload);
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchAllInventory: async () => {
        try {
            const response = await axiosInstance.get('/inventory/all');
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },

}

export default inventoryService